import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectskalpataru } from "../../../../data/projects/kalpataru/data";

export const KalpataruAdvay = () => {
  const {
    kalpataruadvay: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectskalpataru;

  return (
    <>
      <Helmet>
        <title>Kalpataru Advay Borivali West, Mumbai | Luxury 2 & 3 BHK Homes</title>

        <meta
          name="description"
          content="Explore Kalpataru Advay in Borivali West, Mumbai – offering premium 2 & 3 BHK residences with world-class amenities, seamless connectivity, and lush green surroundings. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="Kalpataru Advay Borivali West, Kalpataru Advay Mumbai, 2 BHK in Borivali West, 3 BHK flats in Borivali, Kalpataru Advay price, luxury apartments in Borivali West, Kalpataru Advay floor plan"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/kalpataru-advay-borivali-west-mumbai"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
